import {AxiosError} from 'axios';

import {
  CreateAccountProvisionErrors,
  CreateAccountProvisionLoginIDErrors,
  CreateAccountValidationErrors
} from 'features/CreateAccount/enums';
import {
  decodeCreateAccountProvisionError,
  decodeCreateAccountProvisionLoginIDError,
  decodeCreateAccountValidationError
} from 'features/CreateAccount/utils/error';

export class ProvisioningError extends Error {
  errorCode: CreateAccountProvisionErrors;
  sessionId: string | undefined;
  error: AxiosError<any>;
  validationOptions: string[];

  constructor({error}: {error: AxiosError<any>}) {
    super(error.message);
    this.errorCode = decodeCreateAccountProvisionError(error);
    this.sessionId = error.response?.data?.id;
    this.error = error;
    this.validationOptions = error.response?.data?.validationOptions || [];
  }
}

export class ProvisioningWithLoginIDError extends Error {
  errorCode: CreateAccountProvisionLoginIDErrors;
  sessionId: string | undefined;
  error: AxiosError<any>;

  constructor({error}: {error: AxiosError<any>}) {
    super(error.message);
    this.errorCode = decodeCreateAccountProvisionLoginIDError(error);
    this.sessionId = error.response?.data?.id;
    this.error = error;
  }
}

export class ValidationError extends Error {
  errorCode: CreateAccountValidationErrors;
  constructor(params: {error: AxiosError<any>} | {errorCode: CreateAccountValidationErrors}) {
    const isAxiosError = 'error' in params;
    if (isAxiosError) {
      const {error} = params;
      super(error.message);
      this.error = error;
      this.errorCode = decodeCreateAccountValidationError(error);
    } else {
      const {errorCode} = params;
      super(errorCode);
      this.errorCode = errorCode;
    }
  }
  error?: AxiosError<any>;
}
